import s from './TooltipDefault.module.css';

const TooltipDefault = ({content, position, children, wrap, size, zIndex, textAlign = 'center', disabled = false, whiteSpace = 'wrap'}) => {
    return (
        <div className={`${s['d-tooltip']}`}>
            {
                !disabled && <div
                    style={{ 'width': size, zIndex: zIndex, textAlign: textAlign, whiteSpace: whiteSpace, boxShadow: 'var(--int-box-shadow-color) 0 2px 2px 1px' }}
                    className={`${s['d-tooltip__content-bubble']} ${wrap ? s['d-tooltip__content-bubble--wrap'] : ''}`}>
                    {content}
                </div>
            }

            {children}
        </div>
    );
}

export default TooltipDefault;